import React, { useMemo, useState, useEffect } from 'react';
import { Box, Tooltip } from '@chakra-ui/react';
import Header from '../header/Header';
import ReportCard from './ReportCard';
import people from '../../../src/public/icons_v2/people.svg';
import dealFlowIcon from '../../../src/public/icons_v2/deal-flow-icon.svg';
import {
  closedDealFounderColumns,
  founderColumns,
  founderPipelineColumns,
  investorColumns,
  invitesColumns,
} from './data';
import DealFlowTable from './DealFlowTable';
import { useSelector } from 'react-redux';
import CreateDealFlowModal from '../modal/CreateDealFlowModal';
import CloseDealFlowModal from '../modal/CloseDealFlowModal';
import { useData } from '../../data';
import { FaHandshake } from 'react-icons/fa';
import { BsPlusCircle } from 'react-icons/bs';
import { Skeleton } from '@chakra-ui/react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import UserService from '../../utils/UserService';
import {
  setCurrentDealFlow as setCurrentDealFlowStore,
  setCurrentPage as setCurrentPageStore,
} from '../../redux-toolkit/reducers/dealFlowSlice';
import { setChatInfo } from '../../redux-toolkit/reducers/chatSlice';
import InviteFounderModal from '../modal/InviteFounderModal';
import { useDisclosure } from '@chakra-ui/react';
import { useMutation } from '../../libs/apis';
import { mutateFunction } from '../../libs/apis';
import { CustomToast } from '../toast/CustomToast';
import CreateConnectionModal from '../modal/CreateConnectionModal';
import { useLocation } from 'react-router-dom';


const DealFlow = () => {
  const dispatch = useDispatch();
  const { addToast } = CustomToast();
  const [currentPage, setCurrentPage] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isCloseDealFlowModalOpen, setIsCloseDealFlowModalOpen] =
    useState(false);
  const [dealFlowData, setDealFlowData] = useState([]);
  const [totalDealFlow, setTotalDealFlow] = useState(0);
  const [openDealFlowData, setOpenDealFlowData] = useState([]);
  const [closeDealFlowData, setClosedDealFlowData] = useState([]);
  const [totalOpenDealFlow, setTotalOpenDealFlow] = useState(0);
  const [totalClosedDealFlow, setTotalClosedDealFlow] = useState(0);
  const [currentDealFlow, setCurrentDealFlow] = useState();
  const [founderPipeline, setFounderPipeline] = useState([]);
  const [totalFounderPipeline, setTotalFounderPipeline] = useState(0);
  const [connectionMessage, setConnectionMessage] = useState('');
  const [connectionUser, setConnectionUser] = useState(null);
  const [invitedEmail, setInvitedEmail] = useState('');

  const { mutate: inviteFounderMutation, isLoading: inviteFounderLoading } = useMutation(mutateFunction);
  const { mutate: requestDealMutation, isLoading: requestDealLoading } = useMutation(mutateFunction);
  const loggedInUserId = useSelector((state) => state?.user?.userInfo?.id);
  const urlParams = new URLSearchParams(window.location.search);
  const createDeal = urlParams.get('createDeal');
  const fromPipeline = urlParams.get('fromPipeline');

  const SUBSCRIPTION_FLAG = process.env.REACT_APP_SUBSCRIPTION_FLAG;

  const { isOpen: isInviteFounderModalOpen, onOpen: onOpenInviteFounderModal, onClose: onCloseInviteFounderModal } = useDisclosure();

  const { isOpen: isCreateConnectionModalOpen, onOpen: onCreateConnectionModalOpen, onClose: onCreateConnectionModalClose } = useDisclosure();


  const itemsPerPage = 10;
  // const companyId = useSelector((state) => state?.company?.companyInfo?.id);

  const onModalClose = () => {
    setIsModalOpen(false);
  };

  const accountType = useSelector(
    (state) => state?.user?.userInfo?.userTypeTitle,
  );
  const [activeTab, setActiveTab] = useState(
    accountType === 'founder' ? 'myDeals' : 'openDeals',
  );

  const columns = useMemo(
    () => (accountType === 'founder' ? founderColumns : investorColumns),
    [accountType],
  );

  const closedColumns = useMemo(() => closedDealFounderColumns, []);

  const fpForFounderColumns = useMemo(() => invitesColumns, []);
  const fpForInvestorColumns = useMemo(() => founderPipelineColumns, []);

  const onPageChange = (selected) => {
    setCurrentPage(selected);
  };

  const location = useLocation();
  const navigate = useNavigate();

  const onRowClick = (row) => {
    dispatch(setCurrentDealFlowStore(row.original));
    UserService.setCurrentDealFlow(row.original);

    if (accountType === 'founder') {
      dispatch(setCurrentPageStore(currentPage));
      UserService.setCurrentPage(currentPage);
    }

    if (
      row.original?.status === 'signed' ||
      row.original?.status === 'closed'
    ) {
      navigate('../view-post-agreement-stage');
    } else {
      if (accountType === 'investor') {
        navigate('../view-term-sheet');
      } else {
        // navigate('../view-term-sheet');
        navigate('../view-deal-flow-termsheets');
      }
    }
  };

  const {
    data: dealFlow,
    isLoading: dealFlowLoading,
    isError: dealFlowError,
    refetch: refetchDealFlow,
  } = useData(
    `deal-flow?page_no=${currentPage + 1}&page_size=${itemsPerPage}`,
    0,
  );

  const { data: dealFlowMetrics, isLoading: dealFlowMetricsLoading } = useData(
    `deal-flow/metrics`,
    0,
  );

  const {
    data: openDealFlow,
    isLoading: openDealFlowLoading,
    isError: openDealFlowError,
    refetch: refetchOpenDeals,
  } = useData(
    `deal-flow/open?page_no=${currentPage + 1}&page_size=${itemsPerPage}`,
    0,
    {},
    1,
    false,
  );

  const {
    data: closedDealFlow,
    isLoading: closedDealFlowLoading,
    isError: closedDealFlowError,
    refetch: refetchClosedDeals,
  } = useData(
    `deal-flow/close?page_no=${currentPage + 1}&page_size=${itemsPerPage}`,
    0,
    {},
    1,
    false,
  );


  const {
    data: fpData,
    isLoading: founderPipelineLoading,
    isError: founderPipelineError,
    refetch: refetchFounderPipeline,
  } = useData(
    `${accountType === 'founder' ? 'founder-pipeline/forFounder' : 'founder-pipeline/forInvestor'}?page_no=${currentPage + 1}&page_size=${itemsPerPage}`,
    0,
    {},
    1,
    false,
  );

  const loggedInUserSubscription = useSelector(
    (state) => state?.user?.userSubscriptionInfo,
  );

  const currentPlanName = loggedInUserSubscription?.subscription_plan?.name;

  useEffect(() => {
    if (createDeal && fromPipeline) {
      if (!(SUBSCRIPTION_FLAG == "on" && currentPlanName?.trim().toLowerCase().includes("free"))) {
        setIsModalOpen(true);
      }
      setActiveTab('invites');
    } else if (fromPipeline) {
      if (accountType == 'founder') {
        setActiveTab('invites');
      } else {
        setActiveTab('founderPipeline');
      }
    }

  }, [createDeal, fromPipeline, currentPlanName]);


  useEffect(() => {
    if (fpData && !founderPipelineError) {
      setFounderPipeline(fpData?.data?.founderPipelines);
      setTotalFounderPipeline(fpData?.data?.totalCount);
    }
  }, [fpData, founderPipelineError]);


  useEffect(() => {
    if (activeTab === 'myDeals') {
      refetchDealFlow();
    } else if (activeTab === 'closedDeals') {
      refetchClosedDeals();
    } else if (activeTab === 'invites' || activeTab === 'founderPipeline') {
      refetchFounderPipeline();
    } else {
      refetchOpenDeals();
    }

    if (!(activeTab === 'invites' || activeTab === 'founderPipeline')) {
      navigate(location.pathname, { replace: true });
    }
  }, [currentPage, activeTab]);

  useEffect(() => {
    if (dealFlow && !dealFlowError) {
      setDealFlowData(dealFlow?.data?.deals);
      setTotalDealFlow(dealFlow?.data?.totalCount);
    }
  }, [dealFlow, dealFlowError]);

  useEffect(() => {
    if (openDealFlow && !openDealFlowError) {
      setOpenDealFlowData(openDealFlow?.data?.deals);
      setTotalOpenDealFlow(openDealFlow?.data?.totalCount);
    }
  }, [openDealFlow, openDealFlowError]);

  useEffect(() => {
    if (closedDealFlow && !closedDealFlowError) {
      setClosedDealFlowData(closedDealFlow?.data?.deals);
      setTotalClosedDealFlow(closedDealFlow?.data?.totalCount);
    }
  }, [closedDealFlow, closedDealFlowError]);

  useEffect(() => {
    if (activeTab === 'openDeals') {
      setCurrentPage(0);
      refetchOpenDeals();
    } else if (activeTab === 'closedDeals') {
      setCurrentPage(0);
      refetchClosedDeals();
    }
  }, [activeTab]);

  const handleActionClick = (row) => {
    setCurrentDealFlow(row);
    setIsCloseDealFlowModalOpen(true);
  };


  const handleLaunchRaise = () => {
    if (SUBSCRIPTION_FLAG == "on" && currentPlanName?.trim().toLowerCase().includes("free")) {
      navigate(`${window.location.pathname}?upgrade=true`, { replace: true });
    } else {
      setIsModalOpen(true);
    }
  }

  const inviteFounder = (email) => {
    inviteFounderMutation({ key: "founder-pipeline/invite", method: "post", data: { email } }, {
      onSuccess: (res) => {
        addToast(res);
        onCloseInviteFounderModal();
        setInvitedEmail('');
      },
      onError: (error) => {
        addToast(
          error?.response?.data?.message || 'Error inviting founder.',
          'error',
        );
      }
    });
  }

  const handleMessage = (userData) => {
    let user = userData?.investor || userData?.founder || userData;
    user = { ...user, connections: userData?.connections };

    if (user) {
      dispatch(setChatInfo(user));
      navigate('../connections');
    }
  };

  const handleConnect = (userData) => {
    const user = userData?.investor || userData?.founder || userData;
    if (user) {
      setConnectionUser(user);
      onCreateConnectionModalOpen();
    }
  };

  const handleRequestTermsheet = (rowData) => {
    const founder = rowData?.founder || rowData;
    const founderId = founder?.id;
    const companyId = founder?.company?.id || founder?.companies?.[0]?.id;

    if (founderId) {
      navigate(`/view-user?userid=${founderId}&usertype=1${companyId ? `&cid=${companyId}` : ''}`);
    }
  };

  const handleRequestDeal = (rowData) => {
    const fpId = rowData?.id;

    if (fpId) {
      requestDealMutation(
        {
          key: 'founder-pipeline/request-deal',
          method: 'post',
          data: { pipeline_id: fpId },
        },
        {
          onSuccess: (res) => {
            addToast(res);
            refetchFounderPipeline();
          },
          onError: (err) => {
            addToast(
              err?.response?.data?.message || 'Error requesting deal',
              'error',
            );
          },
        },
      );
    }
  };

  const handleCreateTermsheet = (rowData) => {
    const deals = rowData?.deals;

    if (deals?.length > 0 && accountType === 'investor') {
      const deal = deals[0];
      dispatch(setCurrentDealFlowStore(deal));
      UserService.setCurrentDealFlow(deal);

      navigate('../view-term-sheet');
    }
  };

  const handleCreateDeal = (actionObj) => {
    // When founder clicks on action button (e.g., "Create Deal"), open the create deal modal
    if (actionObj?.action === 'create_deal') {
      if (SUBSCRIPTION_FLAG == "on" && currentPlanName?.trim().toLowerCase().includes("free")) {
        navigate(`${window.location.pathname}?upgrade=true`, { replace: true });
      } else {
        setIsModalOpen(true);
      }
    }
  };

  return (
    <Box>
      <CreateDealFlowModal
        isOpen={isModalOpen}
        onClose={onModalClose}
        currentPage={currentPage}
        itemsPerPage={itemsPerPage}
        onComplete={() => {
          if (activeTab === 'founderPipeline' || activeTab === 'invites') {
            refetchFounderPipeline();
          }
        }}
      />

      <CloseDealFlowModal
        isOpen={isCloseDealFlowModalOpen}
        onClose={() => {
          setIsCloseDealFlowModalOpen(false);
          setActiveTab(accountType === 'founder' ? 'myDeals' : 'openDeals');
        }}
        dealFlowId={currentDealFlow?.id}
        currentPage={currentPage}
        openTermsheetsCount={currentDealFlow?.open_termsheets}
        itemsPerPage={itemsPerPage}
      />

      <InviteFounderModal
        isOpen={isInviteFounderModalOpen}
        onClose={onCloseInviteFounderModal}
        onSend={inviteFounder}
        isLoading={inviteFounderLoading}
        invitedEmail={invitedEmail}
        setInvitedEmail={setInvitedEmail}
      />

      <CreateConnectionModal
        isOpen={isCreateConnectionModalOpen}
        onClose={onCreateConnectionModalClose}
        message={connectionMessage}
        setMessage={setConnectionMessage}
        user={connectionUser}
        onCompleteAction={() => {
          onCreateConnectionModalClose();
          refetchFounderPipeline();
        }}
      />

      <Header title={'Deal Flow'} />
      <Box className="flex w-full bg-gray-100 h-[calc(100vh-80px)] max-w-full overflow-hidden">
        <Box className={`pt-4 px-5 w-full h-full max-w-full overflow-hidden flex flex-col`}>
          <Box className="w-full flex-1 flex flex-col gap-6 p-4 bg-white mb-5 rounded-lg overflow-y-auto hide-scroll max-w-full min-h-0">
            {/* report card section */}
            <section className="flex flex-col-reverse gap-6 xl:gap-0 xl:flex-row items-start justify-between">
              <div className="w-full flex flex-col sm:flex-row items-center gap-6">
                <ReportCard
                  count={
                    accountType === 'founder'
                      ? dealFlowMetrics?.data?.noOfInvestors
                      : dealFlowMetrics?.data?.noOfFounders
                  }
                  updatedAt={new Date()}
                  title={accountType === 'founder' ? 'Investors' : 'Founders'}
                  percentage={31}
                  type={accountType === 'founder' ? 'founders' : 'investors'}
                  image={people}
                  isLoading={dealFlowMetricsLoading}
                />
                <ReportCard
                  count={dealFlowMetrics?.data?.noOfDeals}
                  updatedAt={new Date()}
                  title={accountType === 'founder' ? 'Raises' : 'Deals'}
                  percentage={31}
                  type="dealFlow"
                  image={dealFlowIcon}
                  isLoading={dealFlowMetricsLoading}
                />
              </div>

              <div className="w-full flex justify-between flex-row xs:flex-col items-start sm:items-end gap-4">
                {(accountType === 'founder') ? (
                  <Tooltip
                    label={SUBSCRIPTION_FLAG == "on" && currentPlanName?.trim().toLowerCase().includes("free") ? "Upgrade to Starter or Pro Plan to launch a raise" : "Begin the process of setting up a new fundraising round"}
                    placement="top"
                  >
                    <button
                      onClick={handleLaunchRaise}
                      className="bg-[#134A70] text-white text-sm sm:text-base px-2 sm:px-4 py-2 rounded w-fit"
                    >
                      Launch a Raise
                    </button>
                  </Tooltip>
                ) : null}

                <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
                  {dealFlowMetricsLoading ? (
                    <Skeleton height="20px" width="100px" />
                  ) : (
                    <div className="whitespace-nowrap text-[#20B962] flex items-center gap-1">
                      <div className="w-3 h-3 rounded-full bg-[#20B962]"></div>
                      <p className="text-sm sm:text-base">
                        {dealFlowMetrics?.data?.noOfDealsInProgress || 0} in
                        progress
                      </p>
                    </div>
                  )}

                  {dealFlowMetricsLoading ? (
                    <Skeleton height="20px" width="100px" />
                  ) : (
                    <div className="whitespace-nowrap text-[#EC981C] flex items-center gap-1">
                      <div className="w-3 h-3 rounded-full bg-[#EC981C]"></div>
                      <p className="text-sm sm:text-base">
                        {dealFlowMetrics?.data?.noOfSheetsSigned || 0} Term
                        Sheet
                      </p>
                    </div>
                  )}

                  {dealFlowMetricsLoading ? (
                    <Skeleton height="20px" width="100px" />
                  ) : (
                    <div className="whitespace-nowrap text-[#CF1137] flex items-center gap-1">
                      <div className="w-3 h-3 rounded-full bg-[#CF1137]"></div>
                      <p className="text-sm sm:text-base">
                        {dealFlowMetrics?.data?.noOfDealsClosed || 0} Deal
                        Closed
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </section>

            <section className="w-full flex flex-col gap-2 max-w-full overflow-hidden flex-1 min-h-0">
              <h1 className="text-xl sm:text-2xl font-bold text-[#2F4B6E] flex-shrink-0">
                {accountType === 'founder' ? 'Raise Funds' : 'Investment Deals'}
              </h1>

              <div className="w-full max-w-full overflow-hidden flex-1 min-h-0 flex flex-col">
                {accountType === 'founder' ? (
                  <div className="w-full flex flex-col gap-6 max-w-full overflow-hidden flex-1 min-h-0">
                    <div className="flex items-center border-b border-gray-200 overflow-x-auto hide-scroll flex-shrink-0">
                      <button
                        onClick={() => setActiveTab('myDeals')}
                        className={`px-6 py-3 font-medium text-sm relative ${activeTab === 'myDeals'
                          ? 'text-[#134A70]'
                          : 'text-gray-500 hover:text-gray-700'
                          }`}
                      >
                        My Deals
                        {activeTab === 'myDeals' && (
                          <div className="absolute bottom-0 left-0 w-full h-0.5 bg-[#134A70]" />
                        )}
                      </button>
                      <button
                        onClick={() => setActiveTab('closedDeals')}
                        className={`px-6 py-3 font-medium text-sm relative ${activeTab === 'openDeals'
                          ? 'text-[#134A70]'
                          : 'text-gray-500 hover:text-gray-700'
                          }`}
                      >
                        Closed Deals
                        {activeTab === 'closedDeals' && (
                          <div className="absolute bottom-0 left-0 w-full h-0.5 bg-[#134A70]" />
                        )}
                      </button>

                      <button
                        onClick={() => setActiveTab('invites')}
                        className={`px-6 py-3 font-medium text-sm relative ${activeTab === 'openDeals'
                          ? 'text-[#134A70]'
                          : 'text-gray-500 hover:text-gray-700'
                          }`}
                      >
                        Invites
                        {activeTab === 'invites' && (
                          <div className="absolute bottom-0 left-0 w-full h-0.5 bg-[#134A70]" />
                        )}
                      </button>
                    </div>

                    {activeTab === 'myDeals' && (
                      <div className="flex-1 min-h-0 overflow-y-auto hide-scroll">
                        <DealFlowTable
                          columns={columns}
                          data={dealFlowData}
                          currentPage={currentPage}
                          onPageChange={onPageChange}
                          pageCount={Math.ceil(totalDealFlow / itemsPerPage)}
                          isLoading={dealFlowLoading}
                          onActionClick={handleActionClick}
                          Fallback={() => (
                            <div className="flex flex-col items-center justify-center py-5 px-4 text-center">
                              <div className="w-24 h-24 mb-6 text-gray-300">
                                <FaHandshake className="w-full h-full" />
                              </div>
                              <h3 className="text-xl font-semibold text-gray-700 mb-2">
                                Start Your Fundraising Journey
                              </h3>
                              <p className="text-gray-500 text-center max-w-md mb-8">
                                Create your first deal flow to start connecting
                                with potential investors and track your
                                fundraising progress.
                              </p>

                              <Tooltip
                                label="Begin the process of setting up a new fundraising round"
                                placement="top"
                              >
                                <button
                                  onClick={() => setIsModalOpen(true)}
                                  className="bg-[#134A70] text-white px-6 py-2 rounded-md hover:bg-[#0f3a5a] transition-colors"
                                >
                                  Start Your First Raise
                                </button>
                              </Tooltip>
                            </div>
                          )}
                          onRowClick={onRowClick}
                        />
                      </div>
                    )}

                    {activeTab === 'closedDeals' && (
                      <div className="flex-1 min-h-0 overflow-y-auto hide-scroll">
                        <DealFlowTable
                          columns={closedColumns}
                          data={closeDealFlowData || []}
                          currentPage={currentPage}
                          onPageChange={onPageChange}
                          pageCount={Math.ceil(
                            totalClosedDealFlow / itemsPerPage,
                          )}
                          isLoading={closedDealFlowLoading}
                          Fallback={() => (
                            <div className="flex flex-col items-center justify-center py-5 px-4 text-center">
                              <div className="w-24 h-24 mb-6 text-gray-300">
                                <FaHandshake className="w-full h-full" />
                              </div>
                              <h3 className="text-xl font-semibold text-gray-700 mb-2 text-center">
                                No Closed Deals Yet
                              </h3>
                              <p className="text-gray-500 text-center max-w-md mb-8">
                                Successfully closed deals will appear here once
                                deals reach their completion. This includes deals
                                that have been finalized with signed agreements
                                and completed transactions.
                              </p>
                            </div>
                          )}
                          onRowClick={onRowClick}
                        />
                      </div>
                    )}


                    {activeTab === 'invites' && (
                      <div className="p-2 flex flex-col gap-6 flex-1 min-h-0">
                        <h1 className="flex-shrink-0">Investor Overview</h1>
                        <div className="flex-1 min-h-0 overflow-y-auto hide-scroll">
                          <DealFlowTable
                            columns={fpForFounderColumns}
                            data={founderPipeline || []}
                            currentPage={currentPage}
                            onPageChange={onPageChange}
                            pageCount={
                              Math.ceil(
                                totalFounderPipeline / itemsPerPage,
                              )
                            }
                            isLoading={founderPipelineLoading}
                            Fallback={() => (
                              <div className="flex flex-col items-center justify-center py-5 px-4 text-center">
                                <div className="w-24 h-24 mb-6 text-gray-300">
                                  <FaHandshake className="w-full h-full" />
                                </div>
                                <h3 className="text-xl font-semibold text-gray-700 mb-2 text-center">
                                  No Investor Invites Yet
                                </h3>
                                <p className="text-gray-500 text-center max-w-md mb-8">
                                  Investors who invite you to their founder pipeline
                                  will appear here.
                                </p>
                              </div>
                            )}
                            onRowClick={() => { }}
                            onConnect={handleConnect}
                            onMessage={handleMessage}
                            onCreateDeal={handleCreateDeal}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                ) : (
                  <div className="w-full flex flex-col gap-6 max-w-full overflow-hidden flex-1 min-h-0">
                    <div className="flex items-center border-b border-gray-200 overflow-x-auto hide-scroll flex-shrink-0">

                      <button
                        onClick={() => setActiveTab('founderPipeline')}
                        className={`px-6 py-3 font-medium text-sm relative ${activeTab === 'founderPipeline'
                          ? 'text-[#134A70]'
                          : 'text-gray-500 hover:text-gray-700'
                          }`}
                      >
                        Founder Pipeline
                        {activeTab === 'founderPipeline' && (
                          <div className="absolute bottom-0 left-0 w-full h-0.5 bg-[#134A70]" />
                        )}
                      </button>

                      <button
                        onClick={() => setActiveTab('openDeals')}
                        className={`px-6 py-3 font-medium text-sm relative ${activeTab === 'openDeals'
                          ? 'text-[#134A70]'
                          : 'text-gray-500 hover:text-gray-700'
                          }`}
                      >
                        Open Deals
                        {activeTab === 'openDeals' && (
                          <div className="absolute bottom-0 left-0 w-full h-0.5 bg-[#134A70]" />
                        )}
                      </button>

                      <button
                        onClick={() => setActiveTab('myDeals')}
                        className={`px-6 py-3 font-medium text-sm relative ${activeTab === 'myDeals'
                          ? 'text-[#134A70]'
                          : 'text-gray-500 hover:text-gray-700'
                          }`}
                      >
                        My Deals
                        {activeTab === 'myDeals' && (
                          <div className="absolute bottom-0 left-0 w-full h-0.5 bg-[#134A70]" />
                        )}
                      </button>

                      <button
                        onClick={() => setActiveTab('closedDeals')}
                        className={`px-6 py-3 font-medium text-sm relative ${activeTab === 'openDeals'
                          ? 'text-[#134A70]'
                          : 'text-gray-500 hover:text-gray-700'
                          }`}
                      >
                        Closed Deals
                        {activeTab === 'closedDeals' && (
                          <div className="absolute bottom-0 left-0 w-full h-0.5 bg-[#134A70]" />
                        )}
                      </button>
                    </div>

                    {activeTab === 'founderPipeline' && (
                      <div className="p-2 flex flex-col gap-6 flex-1 min-h-0">
                        <div className="flex justify-end flex-shrink-0">
                          <button
                            onClick={onOpenInviteFounderModal}
                            className="bg-[#134A70] text-white text-sm sm:text-base px-4 py-2 rounded flex items-center gap-2 hover:bg-[#0f3a5a] transition-colors"
                          >
                            <BsPlusCircle className="w-4 h-4 hidden sm:block" />
                            Invite Founder
                          </button>
                        </div>

                        <div className="flex-1 min-h-0 overflow-y-auto hide-scroll">
                          <DealFlowTable
                            columns={fpForInvestorColumns}
                            data={founderPipeline || []}
                            currentPage={currentPage}
                            onPageChange={onPageChange}
                            pageCount={Math.ceil(
                              totalFounderPipeline / itemsPerPage,
                            )}
                            isLoading={founderPipelineLoading}
                            Fallback={() => (
                              <div className="flex flex-col items-center justify-center py-5 px-4 text-center">
                                <div className="w-24 h-24 mb-6 text-gray-300">
                                  <FaHandshake className="w-full h-full" />
                                </div>
                                <h3 className="text-xl font-semibold text-gray-700 mb-2">
                                  No Founders in Pipeline Yet
                                </h3>
                                <p className="text-gray-500 text-center max-w-md mb-8">
                                  Founders you add to your pipeline will appear here.
                                </p>
                              </div>
                            )}
                            onConnect={handleConnect}
                            onMessage={handleMessage}
                            onRequestTermsheet={handleRequestTermsheet}
                            onRequestDeal={handleRequestDeal}
                            onCreateTermsheet={handleCreateTermsheet}
                            requestDealLoading={requestDealLoading}
                            onRowClick={() => { }}
                          />
                        </div>
                      </div>
                    )}

                    {activeTab === 'myDeals' && (
                      <div className="flex-1 min-h-0 overflow-y-auto hide-scroll">
                        <DealFlowTable
                          columns={columns}
                          data={dealFlowData || []}
                          currentPage={currentPage}
                          onPageChange={onPageChange}
                          pageCount={Math.ceil(totalDealFlow / itemsPerPage)}
                          isLoading={dealFlowLoading}
                          Fallback={() => (
                            <div className="flex flex-col items-center justify-center py-5 px-4 text-center">
                              <div className="w-24 h-24 mb-6 text-gray-300">
                                <FaHandshake className="w-full h-full" />
                              </div>
                              <h3 className="text-xl font-semibold text-gray-700 mb-2">
                                No Investment Opportunities Yet
                              </h3>
                              <p className="text-gray-500 text-center max-w-md mb-8">
                                Deal flows will appear here when founders share
                                their investment opportunities with you. Browse
                                the marketplace to discover potential investments.
                              </p>
                            </div>
                          )}
                          onRowClick={onRowClick}
                        />
                      </div>
                    )}

                    {activeTab === 'openDeals' && (
                      <div className="flex-1 min-h-0 overflow-y-auto hide-scroll">
                        <DealFlowTable
                          columns={columns}
                          data={openDealFlowData || []}
                          currentPage={currentPage}
                          onPageChange={onPageChange}
                          pageCount={Math.ceil(totalOpenDealFlow / itemsPerPage)}
                          isLoading={openDealFlowLoading}
                          Fallback={() => (
                            <div className="flex flex-col items-center justify-center py-5 px-4 text-center">
                              <div className="w-24 h-24 mb-6 text-gray-300">
                                <FaHandshake className="w-full h-full" />
                              </div>
                              <h3 className="text-xl font-semibold text-gray-700 mb-2 text-center">
                                No Investment Opportunities Yet
                              </h3>
                              <p className="text-gray-500 text-center max-w-md mb-8">
                                Deal flows will appear here when founders share
                                their investment opportunities with you. Browse
                                the marketplace to discover potential investments.
                              </p>
                            </div>
                          )}
                          onRowClick={onRowClick}
                        />
                      </div>
                    )}

                    {activeTab === 'closedDeals' && (
                      <div className="flex-1 min-h-0 overflow-y-auto hide-scroll">
                        <DealFlowTable
                          columns={columns}
                          data={closeDealFlowData || []}
                          currentPage={currentPage}
                          onPageChange={onPageChange}
                          pageCount={Math.ceil(
                            totalClosedDealFlow / itemsPerPage,
                          )}
                          isLoading={closedDealFlowLoading}
                          Fallback={() => (
                            <div className="flex flex-col items-center justify-center py-5 px-4 text-center">
                              <div className="w-24 h-24 mb-6 text-gray-300">
                                <FaHandshake className="w-full h-full" />
                              </div>
                              <h3 className="text-xl font-semibold text-gray-700 mb-2 text-center">
                                No Closed Deals Yet
                              </h3>
                              <p className="text-gray-500 text-center max-w-md mb-8">
                                Successfully closed deals will appear here once
                                deals reach their completion. This includes deals
                                that have been finalized with signed agreements
                                and completed transactions.
                              </p>
                            </div>
                          )}
                          onRowClick={onRowClick}
                        />
                      </div>
                    )}
                  </div>
                )}
              </div>
            </section>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default DealFlow;
